import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sponsors/logos/sportec.png'


const _withScopeId = n => (_pushScopeId("data-v-11ac7ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Fototävling 2021", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vänligen ange tävlingskoden som finns i Nationellt Pistolskytte 1/2021. ", -1))
const _hoisted_4 = { class: "row mt-3 mb-3" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tävlingskod", -1))
const _hoisted_7 = { class: "text-danger" }
const _hoisted_8 = { class: "row mt-3 mb-3" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "row mt-3 mb-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Tack för ditt bidrag till årets fototävling."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Vinnarna kommer att presenteras i Nationellt Pistolskytte utgåva 4/2021. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vi önskar dig lycka till i tävlingen.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Peter Stålbrand & Anna Stålbrand"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Chefredaktörer")
], -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"row mt-3 mb-3\" data-v-11ac7ca2><div class=\"col-md-8\" data-v-11ac7ca2><h5 data-v-11ac7ca2>Regler för tävlingen</h5><ul data-v-11ac7ca2><li data-v-11ac7ca2> Den tävlande skall vara medlem i någon av Svenska Pistolskytteförbundets föreningar. </li><li data-v-11ac7ca2> Varje tävlande får ställa upp med max 3 bilder, men endast en bild per tävlande kan vinna pris. </li><li data-v-11ac7ca2> Bilderna skall ha en anknytning till Svenska Pistolskytteförbundets verksamhet. </li><li data-v-11ac7ca2> Du måste själv inneha upphovsrätten till bilderna du tävlar med. </li><li data-v-11ac7ca2> Det är tillåtet med färgkorrigeringar, justeringar av skärpa och beskärningar av bilden. Övrig manipulation som till exempel friläggningar eller förändringar av innehållet i bilden är ej tillåtet. </li><li data-v-11ac7ca2> Svenska Pistolskytteförbundet äger rätten att använda de inskickade bidragen i tidningen Nationellt Pistolskytte eller i något av förbundets övriga tryckta eller digitala publikationer. </li><li data-v-11ac7ca2> Bidragen skall vara inskickade senast den 1 november 2021. </li></ul><h5 data-v-11ac7ca2>Priser</h5><p data-v-11ac7ca2> De tre bästa vinnarna kommer att premieras med ett presentkort från Sportec AB. Beloppen på presentkorten kommer att fördelas enligt följande: </p><ul data-v-11ac7ca2><li data-v-11ac7ca2>1:a pris – Presentkort 1 500 kr</li><li data-v-11ac7ca2>2:a pris – Presentkort 1 000 kr</li><li data-v-11ac7ca2>3:e pris – Presentkort 500 kr</li></ul><a href=\"https://www.sportec.se/\" target=\"_new\" data-v-11ac7ca2><img src=\"" + _imports_0 + "\" data-v-11ac7ca2></a></div></div><div class=\"row mt-3 mb-3\" data-v-11ac7ca2><div class=\"col-md-8\" data-v-11ac7ca2><hr data-v-11ac7ca2></div></div>", 2)
const _hoisted_19 = { class: "row mt-3 mb-3" }
const _hoisted_20 = { class: "col-md-8" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Skicka ditt bidrag till tävlingen", -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "row mt-3 mb-3" }
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-danger",
  role: "alert"
}, " Du har redan deltagit i tävlingen. ", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "col-md-8 image-card" }
const _hoisted_35 = { class: "image-card-header" }
const _hoisted_36 = { class: "row mt-3 mb-3" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Bild", -1))
const _hoisted_39 = { class: "col-md-8" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Bildbeskrivning", -1))
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "row mt-3 mb-3" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "row mt-3 mb-3"
}
const _hoisted_46 = { class: "col-md-12" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "progress" }
const _hoisted_52 = ["aria-valuenow"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "text-danger" }
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_field_errors = _resolveComponent("field-errors")!
  const _component_image_upload = _resolveComponent("image-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!_ctx.state.codecorrect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.code) = $event)),
                class: "form-control form-control-sm"
              }, null, 512), [
                [_vModelText, _ctx.state.code]
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.state.codeValidationMessage), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateCode && _ctx.validateCode(...args)))
              }, " Fortsätt ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.codecorrect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.state.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
            : _createCommentVNode("", true),
          (!_ctx.state.sent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_text_field, {
                          label: "Namn",
                          onInput: _ctx.validateForm,
                          modelValue: _ctx.state.form.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.form.name) = $event))
                        }, null, 8, ["onInput", "modelValue"]),
                        _createVNode(_component_field_errors, {
                          errors: _ctx.state.form.errors,
                          single: true,
                          field: "name"
                        }, null, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_text_field, {
                          label: "E-post adress",
                          onInput: _ctx.validateForm,
                          modelValue: _ctx.state.form.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.email) = $event))
                        }, null, 8, ["onInput", "modelValue"]),
                        _createVNode(_component_field_errors, {
                          errors: _ctx.state.form.errors,
                          single: true,
                          field: "email"
                        }, null, 8, ["errors"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_text_field, {
                          label: "Telefon",
                          onInput: _ctx.validateForm,
                          modelValue: _ctx.state.form.phone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.form.phone) = $event))
                        }, null, 8, ["onInput", "modelValue"]),
                        _createVNode(_component_field_errors, {
                          errors: _ctx.state.form.errors,
                          single: true,
                          field: "phone"
                        }, null, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_text_field, {
                          label: "Pistolskyttekortsnummer",
                          onInput: _ctx.validateForm,
                          modelValue: _ctx.state.form.psk,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.form.psk) = $event))
                        }, null, 8, ["onInput", "modelValue"]),
                        _createVNode(_component_field_errors, {
                          errors: _ctx.state.form.errors,
                          single: true,
                          field: "psk"
                        }, null, 8, ["errors"])
                      ])
                    ])
                  ])
                ]),
                (!_ctx.state.canContribute)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                  : _createCommentVNode("", true),
                (_ctx.state.canContribute)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.form.pictures, (picture, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: picture.id,
                          class: "row mt-3 mb-3"
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h6", null, "Bild " + _toDisplayString(index + 1), 1)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createVNode(_component_image_upload, {
                                  accept: "image/jpeg",
                                  onFileAdded: (file) => _ctx.imageAdded(file, picture.id),
                                  onFileRemoved: () => _ctx.imageRemoved(picture.id)
                                }, null, 8, ["onFileAdded", "onFileRemoved"]),
                                _createVNode(_component_field_errors, {
                                  errors: picture.errors,
                                  single: true,
                                  field: "picture"
                                }, null, 8, ["errors"])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control form-control-sm",
                                  rows: "4",
                                  "onUpdate:modelValue": ($event: any) => ((picture.description) = $event),
                                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)))
                                }, null, 40, _hoisted_41), [
                                  [_vModelText, picture.description]
                                ]),
                                _createVNode(_component_field_errors, {
                                  errors: picture.errors,
                                  single: true,
                                  field: "description"
                                }, null, 8, ["errors"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                (!_ctx.hasMinPictures)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-sm btn-secondary",
                                      onClick: ($event: any) => (_ctx.deletePicture(picture.id))
                                    }, " Ta bort bild ", 8, _hoisted_44))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.hasMaxPictures)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addPicture && _ctx.addPicture(...args))),
                                disabled: _ctx.state.submitInProgress,
                                class: "btn btn-secondary btn-sm"
                              }, " Lägg till ytterligare bild ", 8, _hoisted_47)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          (_ctx.state.submitInProgress)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.state.submitMessage), 1),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", {
                                    class: "progress-bar",
                                    role: "progressbar",
                                    style: _normalizeStyle('width: ' + _ctx.state.submitProgress + '%'),
                                    "aria-valuenow": _ctx.state.submitProgress,
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }, _toDisplayString(_ctx.state.submitProgress) + "% ", 13, _hoisted_52)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.submitError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.state.submitError), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: _ctx.hasErrors || _ctx.state.submitInProgress,
                            class: "btn btn-primary mt-3",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                          }, " Skicka bidrag till tävlingen ", 8, _hoisted_55)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}